import React, { ReactNode } from 'react';
import View from '../../atoms/view';
import { FelaExtend, ThemedStyleProps, ThemesProp } from '../../../types/fela';

type MainContainerProps = {
  children?: ReactNode;
  extend?: FelaExtend;
  themes: ThemesProp;
  setActive?: boolean;
};

const MainContainer = ({ children, extend, themes, setActive = true }: MainContainerProps) => {
  const [state] = React.useState(setActive);

  return (
    <View
      extend={
        !state
          ? styles.sidebar_inactive
          : [
              styles.sidebar_active,
              themes.device === 'desktop'
                ? styles.sidebar_desktop
                : themes.device === 'tablet'
                  ? styles.sidebar_tablet
                  : themes.device === 'mobile' && styles.sidebar_mobile,
              extend,
            ]
      }
    >
      {children}
    </View>
  );
};

const styles = {
  sidebar_active: ({ theme: { colors } }: ThemedStyleProps) => ({
    backgroundColor: colors.lightGrey,
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    zIndex: 5,
    borderRight: '1px solid rgb(240, 240, 240)',
    overflowY: 'auto',
    paddingBottom: '24px',
  }),
  sidebar_inactive: {
    display: 'none',
  },
  sidebar_desktop: () => ({}),
  sidebar_tablet: () => ({}),
  sidebar_mobile: () => ({}),
};

export default MainContainer;
